import axios from "axios";

export const client = (method, path, data, headers) => {
    return axios({
        url: (window?._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL) + path,
        method: method || 'GET',
        headers: headers,
        data: data
    });
}